import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Chapter, Reveal } from "./Reveal";

const FAQS = [
  {
    q: "What is Rupora?",
    a: "Rupora is a USDT to INR exchange platform. You deposit USDT on the TRON (TRC20) network and receive Indian Rupees directly in your bank account.",
  },
  {
    q: "How can I exchange USDT to INR?",
    a: "Create your account in the Rupora app, deposit USDT (TRC20), submit your exchange request, and the INR payout is processed to your linked bank account.",
  },
  {
    q: "Which network is supported?",
    a: "Rupora supports USDT deposits on the TRON (TRC20) network. Always send TRC20 USDT to your deposit address — other networks are not supported.",
  },
  {
    q: "How do I deposit USDT?",
    a: "Open the app, copy your unique TRC20 deposit address, and transfer USDT from your wallet or exchange. Your balance updates after network confirmation.",
  },
  {
    q: "How do I withdraw INR?",
    a: "Add your Indian bank account in the app, submit your exchange request, and the INR amount is credited to your bank once the exchange is processed.",
  },
  {
    q: "How long does processing take?",
    a: "Processing time depends on TRON network confirmations and banking hours. You can follow the live status of every request inside the app.",
  },
  {
    q: "Is the Rupora app available on Android?",
    a: "Yes. Tap Download App on this page to download the Rupora Android app directly — quick, free and secure.",
  },
  {
    q: "How can I contact support?",
    a: "Support is available inside the Rupora app. Open the app and use the support section to reach the team about any deposit, exchange or payout.",
  },
];

export default function Faq() {
  return (
    <section id="faqs" className="border-t border-line/70 bg-pine/40" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 py-24 sm:px-8 lg:py-32">
        <Chapter index="07" label="FAQs" />
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl font-semibold tracking-tighter text-paper sm:text-5xl">
            Questions, <span className="text-brand-400">answered.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-line" data-testid={`faq-item-${i + 1}`}>
                <AccordionTrigger className="py-6 text-left font-display text-lg font-medium tracking-tight text-paper transition-colors hover:text-brand-300 hover:no-underline sm:text-xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-mist">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
